import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './public/login/login.component';
import { MainComponent } from './private/layout/main/main.component';
import { HomeComponent } from './private/modules/home/home.component';
import { ForgetComponent } from './public/forget/forget.component';
import { ResetComponent } from './public/reset/reset.component';
import { LeadComponent } from './private/modules/lead/lead.component';
import { LeadProfilePageComponent } from './private/modules/lead/lead-profile-page/lead-profile-page.component';
import { UsersComponent } from './private/modules/configuration/users/users.component';
import { AuthGuard } from './utils/auth.guard';
import { ScheduleComponent } from './private/modules/configuration/schedule/schedule.component';
import { EmailSettingsComponent } from './private/modules/configuration/email-settings/email-settings.component';
import { CampaignManagementComponent } from './private/modules/components/campaign-management/campaign-management.component';
import { LeadsComponent } from './private/modules/configuration/leads/leads.component';
import { RegistrationComponent } from './private/modules/configuration/registration/registration.component';
import { LeadFormComponent } from './public/lead-form/lead-form.component';
import { NotFoundComponent } from './public/not-found/not-found.component';
import { UnauthorizedComponent } from './public/unauthorized/unauthorized.component';
import { WhatsappComponent } from './private/modules/configuration/whatsapp/whatsapp.component';
import { ContactsComponent } from './private/modules/contacts/contacts.component';
import { ContactProfilePageComponent } from './private/modules/contacts/contact-profile-page/contact-profile-page.component';
import { UserLogsComponent } from './private/modules/user-logs/user-logs.component';
import { EventsComponent } from './private/modules/events/events.component';
import { WhatsappTemplateComponent } from './private/modules/configuration/whatsapp-template/whatsapp-template.component';
import { EmailTemplateComponent } from './private/modules/configuration/email-template/email-template.component';
import { ContactGroupsComponent } from './private/modules/configuration/contact-groups/contact-groups.component';
import { BroadcastCampaignComponent } from './private/modules/configuration/broadcast-campaign/broadcast-campaign.component';
import { CampaignSegmentsComponent } from './private/modules/configuration/campaign-segments/campaign-segments.component';
import { AiAgentFlowsComponent } from './private/modules/configuration/ai-agent-flows/ai-agent-flows.component';
import { WhatsappVoiceCampaignComponent } from './private/modules/configuration/whatsapp-voice-campaign/whatsapp-voice-campaign.component';
import { RingOverComponent } from 'src/app/private/modules/components/ring-over/ring-over.component';
import { SalesMailHubComponent } from 'src/app/private/modules/configuration/sales-mail-hub/sales-mail-hub.component';
import { TicketsComponent } from 'src/app/private/modules/tickets/tickets.component';
import { WoocommerceInventoryComponent } from './private/modules/woocommerce-inventory/woocommerce-inventory.component';
import { ManageWooOrdersComponent } from './private/modules/manage-woo-orders/manage-woo-orders.component';
import { CompanyComponent } from 'src/app/private/modules/configuration/company/company.component';
import { DealsComponent } from 'src/app/private/modules/deals/deals.component';
import { InvoiceComponent } from 'src/app/private/modules/invoice/invoice.component';
import { QuoteComponent } from 'src/app/private/modules/quote/quote.component';
import { PipelineComponent } from 'src/app/private/modules/configuration/pipeline/pipeline.component';
import { PublicGuard } from 'src/app/utils/public.guard';
import { subscriptionBillingLockGuard } from 'src/app/utils/subscription-billing-lock.guard';
import { ProductsComponent } from 'src/app/private/modules/products/products.component';
import { CategoryComponent } from 'src/app/private/modules/configuration/category/category.component';
import { TaxesComponent } from 'src/app/private/modules/configuration/taxes/taxes.component';
import { SequencesComponent } from './private/modules/configuration/sequences/sequences.component';
import { SequenceDetailComponent } from './private/modules/configuration/sequence-detail/sequence-detail.component';
import { ManageTeamsComponent } from 'src/app/private/modules/configuration/manage-teams/manage-teams.component';
import { ForecastComponent } from 'src/app/private/modules/forecast/forecast.component';
import { ViewForecastComponent } from 'src/app/private/modules/components/forecast/view-forecast/view-forecast.component';
import { ReportComponent } from 'src/app/private/modules/report/report.component';
import { LeadReportDetailsComponent } from 'src/app/private/modules/components/report/lead-report-details/lead-report-details.component';
import { DealsReportDetailsComponent } from 'src/app/private/modules/components/report/deals-report-details/deals-report-details.component';
import { TicketDetailsReportComponent } from 'src/app/private/modules/components/report/ticket-details-report/ticket-details-report.component';
import { AnalyticsComponent } from 'src/app/private/modules/analytics/analytics.component';
import { CampaignReportComponent } from 'src/app/private/modules/components/report/campaign/campaign-report/campaign-report.component';
import { CampaignReportDetailsComponent } from 'src/app/private/modules/components/report/campaign/campaign-report-details/campaign-report-details.component';
import { DomainAuthenticationComponent } from 'src/app/private/modules/configuration/domain-authentication/domain-authentication.component';
import { ManageAccountFieldComponent } from 'src/app/private/modules/configuration/manage-account-field/manage-account-field.component';
import { ManageContactFieldComponent } from 'src/app/private/modules/configuration/manage-contact-field/manage-contact-field.component';
import { LearningComponent } from 'src/app/private/modules/learning/learning.component';
import { ProjectComponent } from './private/modules/project/project.component';
import { ProjectDetailComponent } from './private/modules/project/project-detail/project-detail.component';
import { ProjectTasksComponent } from './private/modules/components/project-tasks/project-tasks.component';
import { BugsComponent } from './private/modules/components/bugs/bug-listing/bugs.component';
import { ProjectReportComponent } from './private/modules/project-reports/project-report/project-report.component';
import { ClientSettingComponent } from './private/modules/configuration/client-setting/client-setting.component';
import { SubscriptionBillingComponent } from './private/modules/configuration/subscription-billing/subscription-billing.component';
import { EmailCampaignAnlayticsComponent } from './private/modules/components/email-campaign-anlaytics/email-campaign-anlaytics.component';
import { WhatsappCampaignAnalyticsComponent } from './private/modules/components/whatsapp-campaign-analytics/whatsapp-campaign-analytics.component';
import { CallCampaignAnalyticsComponent } from './private/modules/components/call-campaign-analytics/call-campaign-analytics.component';
import { RoleBasedAccessControlComponent } from './private/modules/configuration/role-based-access-control/role-based-access-control.component';
import { ManageDepartmentsComponent } from './private/modules/configuration/manage-departments/manage-departments.component';
import { ManageCentersComponent } from './private/modules/configuration/manage-centers/manage-centers.component';
import { ManageBussinessInfoComponent } from './private/modules/configuration/manage-bussiness-info/manage-bussiness-info.component';
import { OnboardingComponent } from './public/onboarding/onboarding.component';
import { CustomerDataDeletionComponent } from './public/customer-data-deletion/customer-data-deletion.component';
import { ChatEmbedComponent } from './public/chat-embed/chat-embed.component';
import { FormBuilderComponent } from './private/modules/configuration/form-builder/form-builder.component';
import { PublicFormComponent } from './public/public-form/public-form.component';
import { CustomerActivityCaptureComponent } from './public/customer-activity-capture/customer-activity-capture.component';
import { ComingSoonComponent } from './private/modules/coming-soon/coming-soon.component';
import { WorkflowAutomationComponent } from './private/modules/automation/workflow-automation/workflow-automation.component';
import { WorkflowBuilderComponent } from './private/modules/automation/workflow-automation/workflow-builder.component';
import {
  AI_BOT_PERMISSION_PARENTS,
  CI_PERMISSION_PARENTS,
  CI_SECTION_MODULES,
  COMING_SOON_PAGES,
  INTEGRATION_CATEGORY_MODULES,
  INTEGRATION_PERMISSION_PARENTS,
} from './private/services/module.config';
import { CustomerIntelligenceComponent } from './private/modules/customer-intelligence/customer-intelligence.component';

const CUSTOMER_INTELLIGENCE_LEGACY_ROUTES: {
  path: string;
  title: string;
  ciSection: string;
}[] = [
  {
    path: 'customer-analytics',
    title: 'Customer Analytics',
    ciSection: 'overview',
  },
  {
    path: 'audience-analytics',
    title: 'Audience Analytics',
    ciSection: 'overview',
  },
  { path: 'customer-health', title: 'Customer Health', ciSection: 'overview' },
  { path: 'churn-retention', title: 'Churn & Retention', ciSection: 'churn' },
  { path: 'next-best-action', title: 'Next Best Action', ciSection: 'nba' },
  {
    path: 'cohort-migration',
    title: 'Cohort Migration',
    ciSection: 'migration',
  },
  { path: 'rfm-engagement', title: 'RFM & Engagement', ciSection: 'rfm' },
  {
    path: 'loyalty-sentiment',
    title: 'Loyalty & Sentiment',
    ciSection: 'loyalty',
  },
  { path: 'ai-recommendations', title: 'AI Recommendations', ciSection: 'nba' },
];
import { WhatsappLiveChatComponent } from './private/modules/whatsapp-live-chat/whatsapp-live-chat.component';
import { WebLiveChatComponent } from './private/modules/web-live-chat/web-live-chat.component';
import { IntegrationsComponent } from './private/modules/integrations/integrations.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
    title: 'TINA',
  },

  {
    path: 'login',
    component: LoginComponent,
    title: 'TINA',
    canActivate: [PublicGuard],
  },
  {
    path: 'forget-password',
    component: ForgetComponent,
    title: 'Forget Password',
    canActivate: [PublicGuard],
  },
  {
    path: 'reset-password/:type/:token',
    component: ResetComponent,
    title: 'Reset Password',
    canActivate: [PublicGuard],
  },
  {
    path: 'complete-onboarding/:token',
    component: OnboardingComponent,
    title: 'Complete Onboarding',
    canActivate: [PublicGuard],
  },
  {
    path: 'delete-my-data',
    component: CustomerDataDeletionComponent,
    title: 'Delete My Data',
    canActivate: [PublicGuard],
  },
  {
    path: 'capture-leads/:client/:center',
    component: LeadFormComponent,
    title: 'TINA',
  },
  {
    path: 'chat-embed',
    component: ChatEmbedComponent,
    title: 'Live Support',
  },
  {
    path: 'p/:token',
    component: PublicFormComponent,
    title: 'Public Form',
  },
  {
    path: 'customer-activity-capture',
    component: CustomerActivityCaptureComponent,
    title: 'User 360 · Activity Simulation',
    canActivate: [AuthGuard],
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
    title: 'Access Denied',
  },
  {
    path: 'main',
    component: MainComponent,
    canActivate: [AuthGuard, subscriptionBillingLockGuard],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full', // Ensures an exact match to redirect
      },
      {
        path: 'home',
        component: HomeComponent,
        title: 'Dashboard Overview',
        data: {
          title: 'Dashboard Overview',
          module: 'home',
        },
        // canActivate: [AuthGuard],
      },
      {
        path: 'leads/:leadId',
        component: LeadProfilePageComponent,
        title: 'Lead Profile',
        data: {
          title: 'Lead Profile',
          module: 'lead',
        },
      },
      {
        path: 'leads',
        component: LeadComponent,
        // canActivate: [AuthGuard],,
        title: 'Manage Leads',
        data: {
          title: 'Manage Leads',
          module: 'lead',
        },
      },
      {
        path: 'lead',
        component: LeadComponent,
        // canActivate: [AuthGuard],,
        title: 'Manage Leads',
        data: {
          title: 'Manage Leads',
          module: 'lead',
        },
      },

      {
        path: 'analytics',
        component: AnalyticsComponent,
        // canActivate: [AuthGuard],,
        title: 'Analytics',
        data: {
          title: 'Analytics',
          module: 'analytics',
        },
      },
      {
        path: 'customer-intelligence',
        component: CustomerIntelligenceComponent,
        title: 'Customer Intelligence',
        data: {
          title: 'Customer Intelligence',
          permissionQueryParam: 'section',
          permissionQueryMap: CI_SECTION_MODULES,
          permissionAnyOf: Object.values(CI_SECTION_MODULES),
          permissionParents: CI_PERMISSION_PARENTS,
          allowParentModule: true,
        },
      },
      ...CUSTOMER_INTELLIGENCE_LEGACY_ROUTES.map((route) => ({
        path: route.path,
        component: CustomerIntelligenceComponent,
        title: route.title,
        data: {
          title: route.title,
          ciSection: route.ciSection,
          module: CI_SECTION_MODULES[route.ciSection],
          permissionParents: CI_PERMISSION_PARENTS,
          allowParentModule: true,
        },
      })),
      {
        path: 'learning',
        component: LearningComponent,
        // canActivate: [AuthGuard],,
        title: 'Learning',
        data: {
          title: 'Learning',
          module: 'learning',
        },
      },
      {
        path: 'web-live-chat',
        component: WebLiveChatComponent,
        title: 'Web Live Chat',
        data: {
          title: 'Web Live Chat',
          module: 'live_chat_support',
        },
      },
      {
        path: 'integrations',
        component: IntegrationsComponent,
        title: 'Integrations & Connectors',
        data: {
          title: 'Integrations Marketplace',
          permissionQueryParam: 'category',
          permissionQueryMap: INTEGRATION_CATEGORY_MODULES,
          permissionAnyOf: Object.values(INTEGRATION_CATEGORY_MODULES),
          permissionParents: INTEGRATION_PERMISSION_PARENTS,
          allowParentModule: true,
        },
      },
      // events
      {
        path: 'events',
        component: EventsComponent,
        // canActivate: [AuthGuard],,
        title: 'Events',
        data: {
          title: 'Manage Events',
          module: 'event',
        },
      },
      {
        path: 'whatsapp-campaigns',
        component: WhatsappComponent,
        // canActivate: [AuthGuard],,
        title: 'WhatsApp Campaigns',
        data: {
          title: 'WhatsApp Campaigns',
        },
      },
      {
        path: 'email-campaign-anlaytics/:id',
        component: EmailCampaignAnlayticsComponent,
        //   // canActivate: [AuthGuard],,
        title: 'Email Campaign Analytics',
        data: {
          title: 'Email Campaign Analytics',
        },
      },
      {
        path: 'whatsapp-campaign-analytics/:id',
        component: WhatsappCampaignAnalyticsComponent,
        //   // canActivate: [AuthGuard],,
        title: 'WhatsApp Campaign Analytics',
        data: {
          title: 'WhatsApp Campaign Analytics',
        },
      },
      {
        path: 'call-campaign-analytics/:id',
        component: CallCampaignAnalyticsComponent,
        title: 'Call Campaign Analytics',
        data: {
          title: 'Call Campaign Analytics',
        },
      },
      {
        path: 'contacts/:contactId',
        component: ContactProfilePageComponent,
        title: 'Contact Profile',
        data: {
          title: 'Contact Profile',
          module: 'contacts',
        },
      },
      {
        path: 'contacts',
        component: ContactsComponent,
        // canActivate: [AuthGuard],,
        title: 'Contacts',
        data: {
          title: 'Contacts',
          module: 'contacts',
        },
      },
      {
        path: 'product-configuration',
        component: ProductsComponent,
        // canActivate: [AuthGuard],,
        title: 'Products Management',
        data: {
          title: 'Products Management',
        },
      },
      {
        path: 'manage-departments',
        component: ManageDepartmentsComponent,
        title: 'Manage Departments',
        data: {
          title: 'Manage Departments',
        },
      },
      {
        path: 'manage-bussiness-info',
        component: ManageBussinessInfoComponent,
        title: 'Manage Bussiness Info',
        data: {
          title: 'Manage Bussiness Info',
        },
      },
      {
        path: 'manage-centers',
        component: ManageCentersComponent,
        title: 'Manage Centers',
        data: {
          title: 'Manage Centers',
        },
      },
      {
        path: 'user-settings',
        component: UsersComponent,
        title: 'Users',
        // canActivate: [AuthGuard],
        data: {
          title: 'Manage Users',
          module: 'setting',
        },
      },
      {
        path: 'role-based-access-control',
        component: RoleBasedAccessControlComponent,
        title: 'Role Based Access Control',
        //   // canActivate: [AuthGuard],,
        data: {
          title: 'Role Based Access Control',
        },
      },
      {
        path: 'campaign',
        component: CampaignManagementComponent,
        title: 'Campaign',
        data: {
          title: 'Campaign Management',
        },
      },
      {
        path: 'user-logs',
        component: UserLogsComponent,
        title: 'User Logs',
        // canActivate: [AuthGuard],,
        data: {
          title: 'User Logs',
          module: 'user_logs',
        },
      },
      {
        path: 'communication_setting',
        component: EmailSettingsComponent,
        // canActivate: [AuthGuard],
        title: 'Email',
        data: {
          title: 'Email Settings',
          module: 'setting',
        },
      },
      {
        path: 'sequences',
        component: SequencesComponent,
        // canActivate: [AuthGuard],,
        title: 'Sequences',
        data: {
          title: 'Sequences',
        },
      },
      {
        path: 'sequence/:id',
        component: SequenceDetailComponent,
        // canActivate: [AuthGuard],,
        title: 'Sequence Detail',
        data: {
          title: 'Sequence Detail',
        },
      },
      {
        path: 'configuration-schedule',
        component: ScheduleComponent,
        // canActivate: [AuthGuard],,
        title: 'Schedule',
        data: {
          title: 'Schedule Settings',
        },
      },
      {
        path: 'configuration-leads',
        component: LeadsComponent,
        // canActivate: [AuthGuard],,
        title: 'Leads',
        data: {
          title: 'Leads Settings',
          module: 'setting',
        },
      },
      {
        path: 'configuration-contact-fields',
        component: ManageContactFieldComponent,
        // canActivate: [AuthGuard],,
        title: 'Manage Contact Fields',
        data: {
          title: 'Contact Fields Settings',
        },
      },
      {
        path: 'configuration-account-fields',
        component: ManageAccountFieldComponent,
        // canActivate: [AuthGuard],,
        title: 'Manage Accounts Fields',
        data: {
          title: 'Accounts Settings',
        },
      },

      {
        path: 'configuration-whatsapp-template',
        component: WhatsappTemplateComponent,
        // canActivate: [AuthGuard],,
        title: 'WhatsApp Template',
        data: {
          title: 'WhatsApp Template Settings',
          module: 'setting',
        },
      },
      {
        path: 'configuration-email-template',
        component: EmailTemplateComponent,
        // canActivate: [AuthGuard],,
        title: 'Email Template',
        data: {
          title: 'Email Template Settings',
          module: 'setting',
        },
      },
      {
        path: 'contact-groups',
        component: ContactGroupsComponent,
        // canActivate: [AuthGuard],,
        title: 'Contact Groups',
        data: {
          title: 'Contact Groups',
          module: 'setting',
        },
      },
      {
        path: 'pipeline',
        component: PipelineComponent,
        // canActivate: [AuthGuard],,
        title: 'Pipeline',
        data: {
          title: 'Pipeline',
          module: 'setting',
        },
      },
      {
        path: 'product-categories',
        component: CategoryComponent,
        // canActivate: [AuthGuard],,
        title: 'Category',
        data: {
          title: 'Category',
        },
      },
      {
        path: 'tax-configuration',
        component: TaxesComponent,
        // canActivate: [AuthGuard],,
        title: 'Taxes',
        data: {
          title: 'Taxes Configuration',
        },
      },
      {
        path: 'account',
        component: CompanyComponent,
        // canActivate: [AuthGuard],,
        title: 'Account',
        data: {
          title: 'Account',
          module: 'account_management',
        },
      },
      {
        path: 'ringover',
        component: RingOverComponent,
        //   // canActivate: [AuthGuard],,
        title: 'Ring Over',
        data: {
          title: 'Ring Over',
        },
      },
      {
        path: 'broadcast-campaigns',
        component: BroadcastCampaignComponent,
        // canActivate: [AuthGuard],,
        title: 'Broadcast Campaigns',
        data: {
          title: 'Broadcast Campaigns',
          module: 'campaign',
        },
      },
      {
        path: 'campaign-segments',
        component: CampaignSegmentsComponent,
        title: 'Campaign Segments',
        data: {
          title: 'Campaign Segments',
          module: 'campaign',
          permissionParents: ['campaign'],
        },
      },
      {
        path: 'workflow-automation/:id',
        component: WorkflowBuilderComponent,
        title: 'Workflow Builder',
        data: {
          title: 'Workflow Builder',
          module: 'workflow_automation',
        },
      },
      {
        path: 'workflow-automation',
        component: WorkflowAutomationComponent,
        title: 'Workflow Automation',
        data: {
          title: 'Workflow Automation',
          module: 'workflow_automation',
        },
      },
      {
        path: 'ai-agent-flows',
        component: AiAgentFlowsComponent,
        title: 'Call Agent Flow',
        data: { title: 'Call Agent Flow', module: 'campaign' },
      },
      {
        path: 'whatsapp-voice-campaigns',
        component: WhatsappVoiceCampaignComponent,
        title: 'Call Campaigns',
        data: { title: 'Call Campaigns', module: 'campaign' },
      },
      {
        path: 'whatsapp-live-chat',
        component: WhatsappLiveChatComponent,
        title: 'WhatsApp Live Chat',
        data: {
          title: 'WhatsApp Live Chat',
          module: 'whatsapp-live-chat',
        },
      },
      {
        path: 'sales-mail-hub',
        component: SalesMailHubComponent,
        // canActivate: [AuthGuard],,
        title: 'Sales Mail Hub',
        data: {
          title: 'Sales Mail Hub',
          module: 'sales-mail-hub',
        },
      },
      {
        path: 'deals',
        component: DealsComponent,
        // canActivate: [AuthGuard],,
        title: 'Deals',
        data: {
          title: 'Deals',
          module: 'deals',
        },
      },
      {
        path: 'invoices',
        component: InvoiceComponent,
        // canActivate: [AuthGuard],,
        title: 'Invoices',
        data: {
          title: 'Invoices',
        },
      },
      {
        path: 'quotes',
        component: QuoteComponent,
        // canActivate: [AuthGuard],,
        title: 'Quotes',
        data: {
          title: 'Quotes',
        },
      },
      {
        path: 'report',
        component: ReportComponent,
        // canActivate: [AuthGuard],,
        title: 'Report',
        data: {
          title: 'Report',
        },
      },
      {
        path: 'report/leads/:slug',
        component: LeadReportDetailsComponent,
        // canActivate: [AuthGuard],,
        title: 'Lead Report',
        data: {
          title: 'Lead Report',
        },
      },
      {
        path: 'report/deals/:slug',
        component: DealsReportDetailsComponent,
        // canActivate: [AuthGuard],,
        title: 'Lead Report',
        data: {
          title: 'Lead Report',
        },
      },
      {
        path: 'report/campaigns/:slug',
        component: CampaignReportDetailsComponent,
        // canActivate: [AuthGuard],,
        title: 'Lead Report',
        data: {
          title: 'Lead Report',
        },
      },
      {
        path: 'report/tickets/:slug',
        component: TicketDetailsReportComponent,
        // canActivate: [AuthGuard],,
        title: 'Lead Report',
        data: {
          title: 'Lead Report',
        },
      },
      {
        path: 'forecast',
        component: ForecastComponent,
        // canActivate: [AuthGuard],,
        title: 'Forecast',
        data: {
          title: 'Forecast',
        },
      },
      {
        path: 'forecast/:id',
        component: ViewForecastComponent,
        // canActivate: [AuthGuard],,
        title: 'Forecast Analysis',
        data: {
          title: 'Forecast Analysis',
        },
      },
      {
        path: 'manage-tickets',
        component: TicketsComponent,
        // canActivate: [AuthGuard],,
        title: 'Manage Tickets',
        data: {
          title: 'Manage Tickets',
        },
      },
      {
        path: 'billing-subscription',
        component: SubscriptionBillingComponent,
        //   // canActivate: [AuthGuard],,
        title: 'Projects',
        data: {
          title: 'Projects',
        },
      },
      {
        path: 'configuration-registration',
        component: RegistrationComponent,
        // canActivate: [AuthGuard],,
        title: 'Registrations',
        data: {
          title: 'Registrations Settings',
        },
      },
      {
        path: 'configuration-form-builder',
        component: FormBuilderComponent,
        title: 'Form Builder',
        data: {
          title: 'Form Builder',
        },
      },
      {
        path: 'woocommerce-inventory',
        component: WoocommerceInventoryComponent,
        // canActivate: [AuthGuard],,
        title: 'Woocommerce Inventory',
        data: {
          title: 'Woocommerce Inventory',
        },
      },
      {
        path: 'woocommerce-orders',
        component: ManageWooOrdersComponent,
        // canActivate: [AuthGuard],,
        title: 'Woocommerce Orders',
        data: {
          title: 'Woocommerce Orders',
        },
      },
      {
        path: 'client-settings/:tab',
        component: ClientSettingComponent,
        //   // canActivate: [AuthGuard],,
        title: 'Client Settings',
        data: {
          title: 'Client Settings',
        },
      },
      {
        path: 'client-settings',
        component: ClientSettingComponent,
        //   // canActivate: [AuthGuard],,
        title: 'Client Settings',
        data: {
          title: 'Client Settings',
        },
      },
      {
        path: 'appointments',
        loadChildren: () =>
          import('./private/modules/appointment/appointment.module').then(
            (m) => m.AppointmentModule,
          ),
        // canActivate: [AuthGuard],,
        title: 'Appointments',
        data: {
          title: 'Manage Appointments',
        },
      },
      {
        path: 'manage-teams',
        component: ManageTeamsComponent,
        // canActivate: [AuthGuard],,
        title: 'Manage Teams',
        data: {
          title: 'Manage Teams',
        },
      },
      {
        path: 'domain-authentication',
        component: DomainAuthenticationComponent,
        // canActivate: [AuthGuard],,
        title: 'Domain Authentication',
        data: {
          title: 'Domain Authentication',
        },
      },
      {
        path: 'manage-projects',
        component: ProjectComponent,
        //   // canActivate: [AuthGuard],,
        title: 'Manage Projects',
        data: {
          title: 'Manage Projects',
        },
      },
      {
        path: 'project-detail/:project_id',
        component: ProjectDetailComponent,
        title: 'Project Detail',
        data: {
          title: 'Project Detail',
        },
      },
      {
        path: 'manage-bugs/:project_id',
        component: BugsComponent,
        //   // canActivate: [AuthGuard],,
        title: 'Manage Bugs',
        data: {
          title: 'Manage Bugs',
        },
      },
      {
        path: 'manage-project-tasks/:project_id',
        component: ProjectTasksComponent,
        //   // canActivate: [AuthGuard],,
        title: 'Manage Tasks',
        data: {
          title: 'Manage Tasks',
        },
      },
      {
        path: 'manage-project-reports/:project_id',
        component: ProjectReportComponent,
        //   // canActivate: [AuthGuard],,
        title: 'Manage Project Reports',
        data: {
          title: 'Manage Project Reports',
        },
      },
      // hrm module (admin only)
      {
        path: 'hrm',
        loadChildren: () =>
          import('./private/modules/hrm/hrm.module').then((m) => m.HrmModule),
        title: 'Human Resources',
        data: {
          title: 'Human Resources',
        },
      },
      // my-desk module (employee self-service — all roles with HRM access)
      {
        path: 'my-desk',
        loadChildren: () =>
          import('./private/modules/my-desk/my-desk.module').then(
            (m) => m.MyDeskModule,
          ),
        title: 'My Desk',
        data: {
          title: 'My Desk',
        },
      },
      ...COMING_SOON_PAGES.map((page) => ({
        path: page.path,
        component: ComingSoonComponent,
        title: page.title,
        data: {
          title: page.title,
          ...(page.module
            ? {
                module: page.module,
                permissionParents: AI_BOT_PERMISSION_PARENTS,
                allowParentModule: true,
              }
            : {}),
        },
      })),
    ],
  },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
